var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth-wrapper auth-v2" },
    [
      _c(
        "b-row",
        { staticClass: "auth-inner m-0" },
        [
          _c("b-link", { staticClass: "brand-logo main__logo__title" }, [
            _c("img", {
              attrs: {
                src: require("../../assets/images/logo/logo.svg"),
                alt: "",
              },
            }),
            _c("h2", { staticClass: "brand-text ml-1 title" }, [
              _vm._v(" Enterprise"),
              _c("br"),
              _c("span", { staticClass: "title_go" }, [_vm._v("GoDigital")]),
            ]),
          ]),
          _c(
            "b-col",
            {
              staticClass: "d-none d-lg-flex align-items-center p-5",
              attrs: { lg: "8" },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "w-100 d-lg-flex align-items-center justify-content-center px-5",
                },
                [
                  _c("b-img", {
                    attrs: {
                      fluid: "",
                      src: _vm.imgUrl,
                      alt: "Reset Password",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "b-col",
            {
              staticClass: "d-flex align-items-center auth-bg px-2 p-lg-5",
              attrs: { lg: "4" },
            },
            [
              _c(
                "b-col",
                {
                  staticClass: "px-xl-2 mx-auto",
                  attrs: { sm: "8", md: "6", lg: "12" },
                },
                [
                  _c("b-card-title", { staticClass: "mb-1" }, [
                    _vm._v(" Reset Password 🔑 "),
                  ]),
                  _c("b-card-text", { staticClass: "mb-2" }, [
                    _vm._v(" Create a new password for your account. "),
                  ]),
                  _c(
                    "b-form",
                    {
                      staticClass: "auth-reset-password-form mt-2",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.resetPassword($event)
                        },
                      },
                    },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "New Password",
                            "label-for": "reset-password-new",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            { staticClass: "input-group-merge" },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "reset-password-new",
                                  type: _vm.passwordFieldType,
                                  name: "reset-password-new",
                                  placeholder: "Enter new password",
                                },
                                model: {
                                  value: _vm.newPassword,
                                  callback: function ($$v) {
                                    _vm.newPassword = $$v
                                  },
                                  expression: "newPassword",
                                },
                              }),
                              _c(
                                "b-input-group-append",
                                { attrs: { "is-text": "" } },
                                [
                                  _c("feather-icon", {
                                    staticClass: "cursor-pointer",
                                    attrs: { icon: _vm.newPasswordToggleIcon },
                                    on: {
                                      click: _vm.toggleNewPasswordVisibility,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Confirm New Password",
                            "label-for": "reset-password-confirm",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            { staticClass: "input-group-merge" },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "reset-password-confirm",
                                  type: _vm.confirmPasswordFieldType,
                                  name: "reset-password-confirm",
                                  placeholder: "Confirm new password",
                                },
                                model: {
                                  value: _vm.confirmPassword,
                                  callback: function ($$v) {
                                    _vm.confirmPassword = $$v
                                  },
                                  expression: "confirmPassword",
                                },
                              }),
                              _c(
                                "b-input-group-append",
                                { attrs: { "is-text": "" } },
                                [
                                  _c("feather-icon", {
                                    staticClass: "cursor-pointer",
                                    attrs: {
                                      icon: _vm.confirmPasswordToggleIcon,
                                    },
                                    on: {
                                      click:
                                        _vm.toggleConfirmPasswordVisibility,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type: "submit",
                            variant: "primary",
                            block: "",
                          },
                        },
                        [_vm._v(" Reset Password ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "p",
                    { staticClass: "text-center mt-2" },
                    [
                      _c(
                        "b-link",
                        { attrs: { to: { name: "auth-login" } } },
                        [
                          _c("feather-icon", {
                            attrs: { icon: "ChevronLeftIcon" },
                          }),
                          _vm._v(" Back to login "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }